// extracted by mini-css-extract-plugin
module.exports = {"page-comp":"B_page-comp__PP4Xt"};